module.exports = __webpack_public_path__ + "static/media/DK_Layout_4.347c3cc9.png";